
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      vxIsSearching: 'search/getIsSearching',
      vxSearchPagination: 'search/getPagination',
      vxSearchResults: 'search/getSearchResults',
      vxStoryContent: 'search/getStoryContent',
      vxCollectionDescription: 'search/getCollectionDescription',
      vxPaginationIndex: 'search/getPaginationIndex',
    }),
    isLastPage() {
      return this.vxSearchResults.pagination.nextPage === 0
    },
    showingXofYProducts() {
      return this.vxStoryContent.showing_xy_results
        .replace('[X]', this.vxSearchPagination.end)
        .replace('[Y]', this.vxSearchPagination.totalResults)
    },
  },
  methods: {
    ...mapActions({
      vxQuerySearchspring: 'search/querySearchspring',
    }),
    ...mapMutations({
      vxSetPage: 'search/setSearchPage',
    }),
    loadMore() {
      this.vxSetPage(this.vxPaginationIndex + 1)
      this.vxQuerySearchspring()
    },
  },
}
